import { makeGraphqlRequestCloud } from 'api/graphql/graphQLClient';
import { Devices } from '@/graphql/cloud/devices/queries/Devices.graphql';
import { Devices as SubscriptionForDevices } from '@/graphql/cloud/devices/subscriptions/Devices.graphql';
import { Device as SubscriptionForDevice } from '@/graphql/cloud/devices/subscriptions/Device.graphql';
import { DeviceLiquids as SubscriptionForDeviceLiquids } from '@/graphql/cloud/devices/subscriptions/DeviceLiquids.graphql';
import { DeviceState as SubscriptionForDeviceState } from '@/graphql/cloud/devices/subscriptions/DeviceState.graphql';
import { DevicesMethodColumn } from '@/graphql/cloud/devices/queries/DevicesMethodColumn.graphql';
import { subscribe } from '@/api/graphql/wsHasuraClient';
import { UpdateDeviceMethodColumn } from '@/graphql/cloud/devices/mutations/UpdateDeviceMethodColumn.graphql';
import { UpdateDeviceMethod } from '@/graphql/cloud/devices/mutations/UpdateDeviceMethod.graphql';
import { UpdateDeviceColumn } from '@/graphql/cloud/devices/mutations/UpdateDeviceColumn.graphql';
import { UpdateDeviceName } from '@/graphql/cloud/devices/mutations/UpdateDeviceName.graphql';
import { DoNotSleep } from '@/graphql/cloud/devices/mutations/DoNotSleep.graphql';
import { RequestDompHistory } from '@/graphql/cloud/devices/mutations/RequestDompHistory.graphql';
import { DompHistory } from '@/graphql/cloud/devices/queries/DompHistory.graphql';

export const apiDevices = {
  subscribeForDevices(onDevices) {
    return subscribe(SubscriptionForDevices, null, ({ devices }) => {
      onDevices(
        devices.map((device) => ({
          ...device,
          ...device.hardware,
        })),
      );
    });
  },
  subscribeForDevice(deviceId, onDevice) {
    return subscribe(SubscriptionForDevice, { deviceId }, ({ device }) => {
      onDevice({
        ...device,
        ...device.private,
        ...device.private.hardware,
      });
    });
  },
  subscribeForDeviceState(deviceId, onState) {
    return subscribe(SubscriptionForDeviceState, { deviceId }, ({ deviceState }) => {
      onState({
        ...deviceState,
        alltesta_details: JSON.parse(deviceState.alltesta_details),
        analog_signal_details: JSON.parse(deviceState.analog_signal_details),
        autosampler_details: JSON.parse(deviceState.autosampler_details),
        autosampler_fraction_collector_details: JSON.parse(
          deviceState.autosampler_fraction_collector_details,
        ),
        cromite_details: JSON.parse(deviceState.cromite_details),
        detector_details: JSON.parse(deviceState.detector_details),
        ethernet_adapter_details: JSON.parse(deviceState.ethernet_adapter_details),
        fraction_collector_valve_details: JSON.parse(deviceState.fraction_collector_valve_details),
        pump_details: JSON.parse(deviceState.pump_details),
        valve_details: JSON.parse(deviceState.valve_details),
        valve_loop_details: JSON.parse(deviceState.valve_loop_details),
        wifi_adapter_details: JSON.parse(deviceState.wifi_adapter_details),
        phase: JSON.parse(deviceState.phase),
      });
    });
  },
  subscribeForDeviceLiquids(deviceId, onDevice) {
    return subscribe(SubscriptionForDeviceLiquids, { deviceId }, ({ device }) => {
      onDevice({
        ...device,
        ...device.private,
        state: {
          ...device.private.state,
          phase: JSON.parse(device.private.state.phase),
        },
      });
    });
  },
  async getDevices() {
    const devices = (await makeGraphqlRequestCloud(Devices)).devices;
    return devices.map((device) => ({
      ...device,
      ...device.hardware,
    }));
  },
  async getDevicesWithMethodColumn() {
    const devices = (await makeGraphqlRequestCloud(DevicesMethodColumn)).devices;
    return devices.map((device) => ({
      ...device,
      ...device.hardware,
    }));
  },
  updateDeviceMethodColumn(deviceId, methodId, columnId) {
    const variables = {
      deviceId,
      methodId,
      columnId,
    };
    return makeGraphqlRequestCloud(UpdateDeviceMethodColumn, variables);
  },
  updateDeviceMethod(deviceId, methodId) {
    const variables = { deviceId, methodId };
    return makeGraphqlRequestCloud(UpdateDeviceMethod, variables);
  },
  updateDeviceColumn(deviceId, columnId) {
    const variables = { deviceId, columnId };
    return makeGraphqlRequestCloud(UpdateDeviceColumn, variables);
  },
  updateDeviceName(deviceId, name) {
    const variables = { deviceId, name };
    return makeGraphqlRequestCloud(UpdateDeviceName, variables);
  },
  doNotSleep(deviceId) {
    const variables = { deviceId, lastVisited: new Date().toISOString() };
    return makeGraphqlRequestCloud(DoNotSleep, variables);
  },
  requestDompHistory(deviceId) {
    const variables = {
      deviceId,
      startedAt: new Date().toISOString(),
    };
    return makeGraphqlRequestCloud(RequestDompHistory, variables);
  },
  getDompHistory(deviceId) {
    const variables = { deviceId };
    return makeGraphqlRequestCloud(DompHistory, variables);
  },
};
